export const MARKETO_MUNCHKIN_ID = '748-MIV-116';
export const MARKETO_URL = '//pages.coursera-for-business.org';
export const LEAN_DATA_CALENDAR_LOCAL_STORAGE_KEY = 'X_SHOULD_SHOW_LEAN_DATA_CALENDAR';
